/* eslint-disable */
import createIcon from '../createIcon';

const IconUploadOutlined = createIcon({
  name: 'icon-upload-outlined',
  content: '<path d="M513.664 128l244.096 244.16-45.248 45.248-167.424-167.488V704h-64V251.072L312.96 419.072l-45.248-45.184z"/><path d="M896 896h-64v-0.32H192V896H128v-256h64v191.68h640V640h64v256z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconUploadOutlined;
